import { render, staticRenderFns } from "./Xc.vue?vue&type=template&id=587959fd&"
import script from "./Xc.vue?vue&type=script&lang=js&"
export * from "./Xc.vue?vue&type=script&lang=js&"
import style0 from "./Xc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports